import { motion, useReducedMotion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { useCartCount } from '../../contexts/StoreContext';
import { shopLabels } from '../../data/shopLabels';

/**
 * De winkelmandknop: een rustig icoon met het aantal erop. Het enige deel van de navigatie dat
 * het aantal leest (useCartCount); iets toevoegen tekent dus alleen deze knop opnieuw.
 */
export function CartButton({
  onClick
}: {
  onClick: () => void;
}) {
  const count = useCartCount();
  return <button type="button" onClick={onClick} aria-label={shopLabels.cart(count)} aria-haspopup="dialog" className="relative flex h-10 w-10 items-center justify-center rounded-full text-ink transition-colors duration-150 ease-soft hover:bg-ink/[0.06]" data-id="element-7993" data-mp="2ifqxst8x64gd">
      <ShoppingBagIcon className="h-[18px] w-[18px]" strokeWidth={1.5} aria-hidden="true" data-id="element-7994" data-mp="s3ui2d66yvoo" />
      {count > 0 && <CountBadge count={count} data-id="element-7995" data-mp="x2nstxu3g8l5" />}
    </button>;
}

/** Het aantal wipt kort op bij elke wijziging: bevestiging zonder de pagina te onderbreken. */
function CountBadge({
  count
}: {
  count: number;
}) {
  const reduced = useReducedMotion();
  return <motion.span key={count} aria-hidden="true" initial={reduced ? false : {
    scale: 1.35
  }} animate={{
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 520,
    damping: 22
  }} className="absolute right-0.5 top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-clay px-1 text-[12px] leading-none tabular-nums text-shell" data-id="element-7996" data-mp="26lo7hjw2jwbu">
      {count}
    </motion.span>;
}